import en from './en'
import es from './es'
import de from './de'

// eslint-disable-next-line
export default { en, es, de }
